import { useState } from "react";
import type { PoolInfo } from "../types/pool";
import "./AddLiquidityForm.css";

interface AddLiquidityFormProps {
  pool: PoolInfo;
  onSuccess: () => void;
  onBack: () => void;
}

export function AddLiquidityForm({
  pool,
  onSuccess,
  onBack,
}: AddLiquidityFormProps) {
  const [amountA, setAmountA] = useState("");
  const [amountB, setAmountB] = useState("");
  const [tickLower, setTickLower] = useState(-60000);
  const [tickUpper, setTickUpper] = useState(60000);
  const [balanced, setBalanced] = useState(true);
  const [slippagePct, setSlippagePct] = useState(0.5);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    await new Promise((r) => setTimeout(r, 1500));
    setSubmitting(false);
    onSuccess();
  };

  const lpShares = amountA && amountB ? Math.round(Number(amountA) * 0.5) : 0;
  const efficiency = 250;

  return (
    <div className="add-liquidity-form screen">
      <header className="form-header">
        <button type="button" className="back-btn" onClick={onBack}>
          ← Back
        </button>
        <h1>Add Liquidity</h1>
      </header>

      <div className="add-liquidity-card">
        <p className="pool-label">
          {pool.tokenA} / {pool.tokenB}
        </p>

        <form onSubmit={handleSubmit} className="add-liquidity-inner">
          <div className="form-row">
            <div className="form-group">
              <label>Amount A ({pool.tokenA})</label>
              <input
                type="text"
                inputMode="decimal"
                value={amountA}
                onChange={(e) => setAmountA(e.target.value)}
                placeholder="0"
              />
            </div>
            <div className="form-group">
              <label>Amount B ({pool.tokenB})</label>
              <input
                type="text"
                inputMode="decimal"
                value={amountB}
                onChange={(e) => setAmountB(e.target.value)}
                placeholder="0"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Tick Range (Concentrated)</label>
            <div className="tick-range">
              <input
                type="number"
                value={tickLower}
                onChange={(e) => setTickLower(Number(e.target.value))}
              />
              <span>to</span>
              <input
                type="number"
                value={tickUpper}
                onChange={(e) => setTickUpper(Number(e.target.value))}
              />
            </div>
          </div>

          <div className="form-group toggle-row">
            <label>
              <input
                type="checkbox"
                checked={balanced}
                onChange={(e) => setBalanced(e.target.checked)}
              />
              Balanced
            </label>
          </div>

          <div className="form-group">
            <label>Slippage Tolerance %</label>
            <input
              type="number"
              step={0.1}
              min={0}
              value={slippagePct}
              onChange={(e) => setSlippagePct(Number(e.target.value) || 0)}
            />
          </div>

          <div className="form-preview">
            <p>
              LP Shares ~{lpShares} · Efficiency: {efficiency}× via ReClamm
            </p>
          </div>

          <div className="form-actions">
            <button type="button" className="secondary" onClick={onBack}>
              Cancel
            </button>
            <button
              type="submit"
              className="primary"
              disabled={submitting || !amountA || !amountB}
            >
              {submitting ? "Adding… (DAG Processing)" : "Approve & Add Liquidity"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
